<div class="w-full overflow-x-hidden">
  <app-home-banner [slides]="bannerSlides" (ctaClick)="onBannerCta($event)" />

  <app-events-list id="home-events-list" />

  @if (shouldShowPromo()) {
    <app-home-benefits [benefits]="benefits" />

    <app-home-cta (createEventClick)="navigateToCreateEvent()"
      (howItWorksClick)="openHowItWorksModal()" />
  }

  <!-- Modal Como Funciona -->
  <app-how-it-works-modal [(visible)]="showHowItWorksModal" />
</div>
